<template>
    <div>
        <MyJobsTray :status=status />
    </div>
</template>

<script>
    import MyJobsTray from "./MyJobsTray";
    export default {
        name: "MyJobTrayPrepared",
        components:{
            MyJobsTray
        },
        props:{
            status : Number
        }
    }
</script>

<style scoped>

</style>